enum ECoinTypeAvailabilityMode {
    FIAT = 'fiat',
    CRYPTO = 'crypto',
    BOTH = 'both',
}

interface ICoinTypeAvailabilityMode {
    FROM: ECoinTypeAvailabilityMode
    TO: ECoinTypeAvailabilityMode
}

export type { ICoinTypeAvailabilityMode }
export { ECoinTypeAvailabilityMode }
